export const NAV_DESTINATION = {
  QUESTION_SET: 'question-set',
  NEXT_LESSON: 'next-lesson',
};
